import { useResponsive } from "@caprikorn/dynamo-utils";
import { type FC, useMemo, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { ErrorBoundary } from "@components/errors/ErrorBoundary/ErrorBoundary";
import { Header } from "@components/Header/Header";
import { Menu } from "@components/Menu/Menu";
import { GroupReferenceProvider } from "@contexts/GroupReferences/GroupReferences.context";
import { MobileMenuContext } from "@contexts/MobileMenu/MobileMenu.context";
import { ROUTES } from "@router/router.constants";
import { isAuthenticated } from "@utils/auth.utils";

import classes from "./AppLayout.module.css";

export const AppLayout: FC = () => {
  const { pathname } = useLocation();
  const authenticated = isAuthenticated();
  const isDesktop = useResponsive() === "desktop";
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const mobileMenuContextValue = useMemo(
    () => ({
      openMobileMenu: isDesktop ? undefined : () => setIsMenuOpen(true),
    }),
    [isDesktop],
  );

  if (authenticated) {
    return (
      <GroupReferenceProvider>
        <MobileMenuContext.Provider value={mobileMenuContextValue}>
          <div className={classes.container}>
            {isDesktop ? (
              <Menu />
            ) : (
              <Menu
                isMobile
                isOpen={isMenuOpen}
                onClose={() => setIsMenuOpen(false)}
              />
            )}
            <ErrorBoundary
              fallbackHeader={
                isDesktop ? undefined : <Header breadcrumbPaths={[]} />
              }
              pathname={pathname}
            >
              <main className={classes.main}>
                <Outlet />
              </main>
            </ErrorBoundary>
          </div>
        </MobileMenuContext.Provider>
      </GroupReferenceProvider>
    );
  }

  return <Navigate to={ROUTES.LOGIN} />;
};
